import script from "./VideoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoDialog.vue?vue&type=script&setup=true&lang=js"

import "./VideoDialog.vue?vue&type=style&index=0&id=52e8b5ab&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52e8b5ab"]])

export default __exports__